export default [
  {
    path: '/admin/product-locations',
    name: 'product-location',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/location')
  },
  {
    path: '/admin/product-locations/create',
    name: 'product-location-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/location/create.vue')
  }
]